import { Input } from "@/components/ui/input";

export const OTHER = "Others";
export const isOther = (v) => v === OTHER || (v || "").startsWith(`${OTHER}: `);
export const selValue = (v) => (isOther(v) ? OTHER : v);
export const otherText = (v) => ((v || "").startsWith(`${OTHER}: `) ? v.slice(OTHER.length + 2) : "");

export function OtherRankInput({ value, onChange, testid }) {
  if (!isOther(value)) return null;
  return (
    <Input value={otherText(value)} placeholder="Type the custom rank name" className="mt-1.5"
      onChange={(e) => onChange(e.target.value ? `${OTHER}: ${e.target.value}` : OTHER)} data-testid={testid} />
  );
}
